// import React from 'react';
import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, [
    'patternType',
    'everyNDay',
    'everyWeekDay',
    'everyWeekEnd',
    'everyNWeek',
    'everyMonday',
    'everyTuesday',
    'everyWednesday',
    'everyThursday',
    'everyFriday',
    'everySaturday',
    'everySunday',
    'dayOfMonth',
    'everyNMonth',
    'everyNYear',
    'dayOfMonth',
    'monthOfYear',
  ]);
  const createSchedulePattern = `createSchedulePattern(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createSchedulePattern} {
      id
    }
  }
`;
};
